import script from './skeleton.vue_vue_type_script_lang.mjs';
export { default } from './skeleton.vue_vue_type_script_lang.mjs';
import { render } from './skeleton.vue_vue_type_template_id_26fa9225_lang.mjs';

script.render = render;
script.__file = "packages/components/skeleton/src/skeleton.vue";
//# sourceMappingURL=skeleton.mjs.map
